import React from "react";
import { motion } from "framer-motion";
import { Cpu, Cloud, Network, Sparkles, Box } from "lucide-react";
import SectionHeader from "../common/sectionHeader";
import INFO from "../../data/user";
import "./styles/learningRoadmap.css";

const getIcon = (iconName) => {
	switch (iconName) {
		case "cpu": return <Cpu size={18} />;
		case "cloud": return <Cloud size={18} />;
		case "network": return <Network size={18} />;
		case "sparkles": return <Sparkles size={18} />;
		case "box": return <Box size={18} />;
		default: return <Cpu size={18} />;
	}
};

const LearningRoadmap = () => {
	return (
		<section className="learning-section">
			<SectionHeader
				tag="Active Growth"
				title="Currently"
				highlight="Exploring & Learning"
				subtitle="Focus areas for deepening architectural knowledge, cloud infrastructure, and emerging AI tooling."
			/>

			<div className="learning-grid">
				{INFO.learning.map((item, index) => (
					<motion.div
						key={index}
						className="learning-card"
						initial={{ opacity: 0, y: 20 }}
						whileInView={{ opacity: 1, y: 0 }}
						viewport={{ once: true }}
						transition={{ duration: 0.35, delay: index * 0.1 }}
					>
						<div className="learning-card-header">
							<div className="learning-icon-box">{getIcon(item.icon)}</div>
							<div className="learning-card-title">{item.title}</div>
						</div>
						<p className="learning-card-desc">{item.description}</p>
						<span className="learning-status-pill">IN PROGRESS</span>
					</motion.div>
				))}
			</div>
		</section>
	);
};

export default LearningRoadmap;
